var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.6C45.4635 33.6 58 39.4501 58 46.6667V56H2V46.6667C2 39.4501 14.5365 33.6 30 33.6ZM54.2667 46.6667C54.2667 41.5147 43.4027 37.3333 30 37.3333C16.5973 37.3333 5.73333 41.5147 5.73333 46.6667V52.2667H54.2667V46.6667ZM30 0C33.4655 0 36.7891 1.37666 39.2395 3.82714C41.69 6.27761 43.0667 9.60117 43.0667 13.0667C43.0667 16.5322 41.69 19.8557 39.2395 22.3062C36.7891 24.7567 33.4655 26.1333 30 26.1333C26.5345 26.1333 23.2109 24.7567 20.7605 22.3062C18.31 19.8557 16.9333 16.5322 16.9333 13.0667C16.9333 9.60117 18.31 6.27761 20.7605 3.82714C23.2109 1.37666 26.5345 0 30 0ZM30 3.73333C27.5246 3.73333 25.1507 4.71666 23.4003 6.467C21.65 8.21734 20.6667 10.5913 20.6667 13.0667C20.6667 15.542 21.65 17.916 23.4003 19.6663C25.1507 21.4167 27.5246 22.4 30 22.4C32.4754 22.4 34.8493 21.4167 36.5997 19.6663C38.35 17.916 39.3333 15.542 39.3333 13.0667C39.3333 10.5913 38.35 8.21734 36.5997 6.467C34.8493 4.71666 32.4754 3.73333 30 3.73333Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4e73a21f1f7ded9ece62396e85e12d0d.svg";
export { ForwardRef as ReactComponent };